import clsx from 'clsx';
import React, { ClassAttributes, HTMLAttributes } from 'react';
import styles from './TableRow.module.css';

export const TableRow = ({
  className,
  ...props
}: JSX.IntrinsicAttributes &
  ClassAttributes<HTMLTableRowElement> &
  HTMLAttributes<HTMLTableRowElement>) => (
  <tr className={clsx(styles.tableRow, className)} {...props} />
);
